import type { Namespace } from '../../../types.js';

export const validation: Namespace = {
  'validation.required': 'Поле обязательно',
  'validation.email': 'Введите корректный email',
  'validation.min_length': 'Минимум {count} символов',
  'validation.max_length': 'Максимум {count} символов',
  'validation.number': 'Введите число',
};
